"use client";

import { cn, dayjs } from "utils";

import React from "react";
import type { NewsItemProps } from "./types";
import NextImage from "@components/NextImage";

/**
 * 新闻项组件 - 用于显示新闻信息
 */
export const NewsItem: React.FC<NewsItemProps> = ({
  news,
  onClick,
  className,
}) => {
  // 获取第一个分类作为显示分类
  const category =
    news?.themes && news?.themes.length > 0 ? news?.themes[0] : "";
  return (
    <div
      data-openreplay-label="home_newsitem_search"
      className={cn(
        "flex items-start gap-3 rounded-3 cursor-pointer transition-colors",
        className,
      )}
      onClick={onClick}
    >
      <div className="rounded-lg w-20 h-20 overflow-hidden">
        <NextImage
          src={news?.image}
          alt={`${category} logo`}
          width={80}
          height={80}
          className="w-full h-full object-cover hover:scale-[1.2] transition-transform duration-300 ease-out"
        />
      </div>
      <div className="flex flex-col flex-1 gap-1">
        <div className="flex flex-col gap-1">
          <p className="body_medium_m text-content_primary line-clamp-2">
            {news.name}
          </p>
        </div>
        <span className="body_s text-content_tertiary whitespace-nowrap">
          {dayjs(news.issue_date).format("MMM D YYYY, HH:mm")}
        </span>
      </div>
    </div>
  );
};
